import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(public messageService: MessageService) { }

  testToast() {
    this.messageService.add({ severity: 'success', summary: 'Teste', detail: 'Funcionando!' });
  }
}
